import * as React from 'react';
import { colors, Typography, Stack } from '@mui/material';

export default function EnvBar({
  accessLevel,
  accessType,
  provider,
  customer,
}) {
  const getEnvColor = () => {
    switch (process.env.REACT_APP_ENV) {
      case 'development':
        return colors.orange[700];
      case 'testing':
        return colors.purple[700];
      case 'staging':
        return colors.green[700];
      case 'production':
        return colors.blue[700];
      default:
        return colors.grey[700];
    }
  };

  const data = [
    { name: 'Provider', value: provider },
    { name: 'Customer', value: customer },
    { name: 'Colour', value: process.env.REACT_APP_COLOUR },
  ];

  return (
    <Stack
      sx={{
        backgroundColor: getEnvColor(),
        paddingX: 2,
        paddingY: 0.5,
        flexDirection: 'row',
        gap: 3,
      }}>
      {accessLevel === '3' && accessType === '3' && provider && customer && (
        <React.Fragment>
          {data.map((item) => (
            <Typography key={item.name} fontSize={12} color="common.white">
              {item.name}: {item.value}
            </Typography>
          ))}
        </React.Fragment>
      )}
    </Stack>
  );
}
